/* eslint-disable */

import React, { Component } from 'react';
import { Link as RouterLink, useNavigate } from 'react-router-dom';
import * as Yup from 'yup';
import { Formik } from 'formik';
import {
  Box,
  Button,
  Card,
  CardContent,
  FormControl,
  FormHelperText,
  Grid,
  IconButton,
  InputLabel,
  InputAdornment,
  TextField,
  Typography,
  useMediaQuery,
  Select,
  Tooltip,
  MenuItem,
  Alert,
  RadioGroup,
  Radio,
  FormLabel,
  FormControlLabel,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Autocomplete,
  Popper,
} from '@mui/material';
import { CheckCircle, Close, Done, Info, Visibility, VisibilityOff } from '@mui/icons-material';
import PasswordStrengthBar from 'react-password-strength-bar';
import AuthServices from '../services/auth';
import { CountryCodes } from './CountryCodes';
import { Link } from 'react-router-dom';
import { DatePicker } from 'antd';
import moment from 'moment';

class RegisterForm extends Component {
  constructor(props) {
    super(props);
    this.state = {
      country_code: '',
      nationality: '',
      dob: '',
      address: '',
      gender: '',
      alertType: '',
      apiMessage: '',
      password: '',
      password2: '',
      showPassword: false,
      showPassword2: false,
      registerState: true,
      investor_email: null,
      confirm: false,
      data: {},
      containLetter: false,
      containNumber: false,
      containSpecial: false,
      minLength: false
    };
    this.myRef = React.createRef()
  }

  handleEmailChanged = (e) => {
    console.log('test', e)
    e.target.value = e.target.value.trim()
  }

  handleClickShowPassword = () => {
    this.setState({
      ...this.state,
      showPassword: !this.state.showPassword
    });
  };

  handleMouseDownPassword = event => {
    event.preventDefault();
  };

  handleClickShowPassword2 = () => {
    this.setState({
      ...this.state,
      showPassword2: !this.state.showPassword2
    });
  };

  handleMouseDownPassword2 = event => {
    event.preventDefault();
  };

  cancelSubmit = () => {
    this.setState({
      ...this.state,
      confirm: false
    })
  }

  confirmSubmit = async () => {
    let _code = this.state.country_code;
    let _data = this.state.data;
    let _finalData;
    Object.keys(_data).map(() => {
      _finalData = {
        ..._data,
        phone_number: _code + _data['phone_number'],
        gender: _data['gender'],
        nationality: this.state.nationality,
        dob: this.state.dob,
        mailing_address: _data['mailing_address'],
      };
      return _finalData;
    });
    this.setState({
      ...this.state,
      investor_email: _data['email']
    });
    try {
      var response = await AuthServices.register(_finalData)
      if (response.status) {
        this.setState({
          ...this.state,
          registerState: false,
          confirm: false,
          country_code: ''
        });
      }
      else this.myRef.current.scrollIntoView({ block: 'center' })
    } catch (e) {
      let error = e.response.data.message;
      this.setState({
        ...this.state,
        confirm: false,
        alertType: 'error',
        apiMessage: error
      });
    }
  }

  checkUsername = () => {
    let _username = document.querySelector('input[name="username"]');
    let _usernameParent = document.querySelector('div.username_container');
    let _hintLabel = document.querySelectorAll('label')[1];
    let _hintText = document.getElementById('username_regex');
    _hintText.style.display = 'none';
    let _parentClasses = _usernameParent.classList;
    _parentClasses.remove('Mui-error');
    _hintLabel.classList.remove('Mui-error');
    var _usernameRegex = new RegExp(
      '^([a-zA-Z])([._-]*|[a-zA-Z0-9]){5,18}([._-]*|[a-zA-Z0-9])$'
    );

    if (_username.value != '') {
      if (
        !_usernameRegex.test(_username.value) ||
        _username.value.length < 5 ||
        _username.value.length > 18
      ) {
        _parentClasses.add('Mui-error');
        _hintLabel.classList.add('Mui-error');
        _hintText.style.display = 'block';
        return false;
      } else {
        _parentClasses.remove('Mui-error');
        _hintLabel.classList.remove('Mui-error');
        _hintText.style.display = 'none';
        return true;
      }
    }
  };

  checkPhoneNumber = () => {
    let _phoneNumber = document.querySelector('input[name="phone_number"]');
    let _phoneNumberParent = document.querySelector(
      'div.phone_number_container'
    );
    let _hintLabel = document.querySelector('.phoneNumber > label');
    let _hintText = document.getElementById('phoneNumberRegex');
    _hintText.style.display = 'none';
    let _parentClasses = _phoneNumberParent.classList;
    _parentClasses.remove('Mui-error');
    _hintLabel.classList.remove('Mui-error');
    var _phoneNumberRegex = new RegExp('[0-9]');

    if (_phoneNumber.value != '') {
      if (
        !_phoneNumberRegex.test(_phoneNumber.value) ||
        _phoneNumber.value.length < 6 ||
        _phoneNumber.value.length > 20
      ) {
        _parentClasses.add('Mui-error');
        _hintLabel.classList.add('Mui-error');
        _hintText.style.display = 'block';
      } else {
        _parentClasses.remove('Mui-error');
        _hintLabel.classList.remove('Mui-error');
        _hintText.style.display = 'none';
      }
    }
  };

  checkPassword = () => {
    var _letterRegex = new RegExp(
      '^(?=.*[a-z])(?=.*[A-Z])'
    );

    var _numberRegex = new RegExp(
      '^(?=.*[0-9])'
    );

    var _specialRegex = new RegExp(
      '^(?=.*[!@#$%^&*])'
    );

    var _lengthRegex = new RegExp(
      '^(?=.{8,})'
    );

    let _password = document.querySelector('input[name="password"]');
    this.setState({
      ...this.state,
      password: _password.value,
      containLetter: _letterRegex.test(_password.value),
      containNumber: _numberRegex.test(_password.value),
      containSpecial: _specialRegex.test(_password.value),
      minLength: _lengthRegex.test(_password.value)
    });
    let _passwordParent = document.querySelector('div.password_container');
    let _hintLabel = document.querySelector('.password > label');
    let _hintText = document.getElementById('password_regex');
    _hintText.style.display = 'none';
    let _parentClasses = _passwordParent.classList;
    _parentClasses.remove('Mui-error');
    _hintLabel.classList.remove('Mui-error');
    var _passwordRegex = new RegExp(
      '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!@#$%^&*])(?=.{8,})'
    );

    if (_password.value != '') {
      if (_passwordRegex.test(_password.value)) {
        _parentClasses.remove('Mui-error');
        _hintLabel.classList.remove('Mui-error');
        _hintText.style.display = 'none';
        return true;
      } else {
        _parentClasses.add('Mui-error');
        _hintLabel.classList.add('Mui-error');
        _hintText.style.display = 'block';
        return false;
      }
    }
  };

  handlePhoneOTP = event => {
    const phoneNumberVal = event.target.value;
    if (phoneNumberVal !== '') {
      console.log('not empty');
    } else {
      console.log('empty');
    }
  };

  defaultPasswordScoreWords = 'Too short';
  passwordScoreWords = ['Weak', 'Okay', 'Better', 'Good', 'Strong'];



  render() {
    const { isSmallScreen } = this.props;
    var query = window.location.search.substring(1);

    const handleSelectChange = (event, value) => {
      this.setState({
        ...this.state,
        country_code: value.dial_code
      });
    };

    const handleNationalityChange = (event, value) => {
      this.setState({
        ...this.state,
        nationality: value.name
      });
    };

    const handleAddress = event => {
      this.setState({
        ...this.state,
        address: event.target.value
      });
    };

    const handleDOB = (date, dateString) => {
      this.setState({
        ...this.state,
        dob: dateString
      });
    };

    const options = CountryCodes.countries.map((option) => {
      const firstLetter = option.name[0].toUpperCase();
      return {
        firstLetter: /[0-9]/.test(firstLetter) ? '0-9' : firstLetter,
        ...option,
      };
    });

    function PasswordException() { }

    PasswordException.prototype = new Error();

    const PopperMy = function (props) {
      return <Popper {...props} style={{ width: "fit-content" }} placement="bottom-start" />;
    };

    const disabledDate = (current) => {
      return current > moment().subtract(18, 'year');
    };

    return (

      <>
        {this.state.registerState ?
          <>
            <div ref={this.myRef}></div>
            {/* <TextDialog
          isOpen={true}
          title={t('registerPage.noticeTitle')}
          content={
            <Typography>
              {t('registerPage.notice1')}<b>{t('registerPage.notice2')}</b>{t('registerPage.notice3')}
              <b>{t('registerPage.notice4')}</b>{t('registerPage.notice5')}<b>info@capitaldynamics.com.au</b>
              {t('registerPage.notice6')}<a href="https://iportal.capitaldynamics.com.au/contact">https://iportal.capitaldynamics.com.au/contact</a>
            </Typography>
          }
          buttonText={'Close'}
        /> */}
            <Grid
              container
              spacing={0}
              direction="column"
              alignItems="center"
              justifyContent="center"
              style={{ minHeight: '100vh' }}
            >
              <Grid item xs={3}>
                <Grid
                  container
                  spacing={0}
                  direction="row"
                  alignItems="center"
                  justifyContent="center"
                  style={{ minHeight: '100vh' }}
                >
                  <Grid item xs={12} md={6} className='logoContainer'
                    textAlign="center">
                    <Box className='registerBackground'>
                      <img src='/logo_black.png' alt="iCapital" className='registerLogo' />
                    </Box>
                  </Grid>
                  <Grid item xs={11} md={6} className="displayBoxBorder">
                    <Box
                      display="flex"
                      flexDirection="column"
                      // height="100vh"
                      justifyContent="center"
                    >
                      {/* {this.state.registerState ? ( */}
                      {/* <Container maxWidth="md"> */}
                      <Box>
                        <Typography
                          variant="h4"
                          align="left"
                        >
                          <b>CREATE ACCOUNT</b>
                        </Typography>
                      </Box>
                      {this.state.apiMessage != '' && (
                        <Box mb={3}>
                          <Alert severity={this.state.alertType}>
                            {this.state.apiMessage}
                          </Alert>
                        </Box>
                      )}
                      <Box>
                        <Formik
                          initialValues={{
                            email: '',
                            username: '',
                            full_name: '',
                            country_code: '',
                            phone_number: '',
                            password: '',
                            password2: '',
                            gender: '',
                            nationality: '',
                            dob: '',
                            mailing_address: '',
                            policy: false
                          }}
                          validationSchema={Yup.object().shape({
                            email: Yup.string()
                              .email('Must be a valid email address')
                              .max(50)
                              .required('Email is required'),
                            username: Yup.string()
                              .max(18)
                              .required('Username is required'),
                            full_name: Yup.string()
                              .max(50)
                              .required('Full name is required'),
                            phone_number: Yup.number().required(
                              'Phone number is required'
                            ),
                            password: Yup.string()
                              .max(50)
                              .required('Password is required'),
                            password2: Yup.string()
                              .max(50)
                              .required('Confirm password is required')
                              .when('password', {
                                is: val => (val && val.length > 0 ? true : false),
                                then: Yup.string().oneOf(
                                  [Yup.ref('password')],
                                  'Confirm password must match password entered'
                                )
                              }),
                            gender: Yup.string().required('Gender is required'),
                            // nationality: Yup.string().required('Nationality is required'),
                            // dob: Yup.string().required('Date of Birth is required'),
                            mailing_address: Yup.string().required('Mailing address is required'),
                            // policy: Yup.boolean().oneOf(
                            //   [true],
                            //   'This check is required'
                            // )
                          })}
                          onSubmit={async data => {
                            try {
                              if (!this.checkPassword()) {
                                throw new PasswordException();
                              }
                              if (this.checkUsername()) {
                                this.setState({
                                  ...this.state,
                                  data: data,
                                  confirm: true
                                });
                              }
                              else this.myRef.current.scrollIntoView({ block: 'center' })
                              // await OTPServices.generateRegisterOTP({
                              //   email: this.state.investor_email
                              // });
                              // document.getElementsByTagName('form')[0].reset();
                            } catch (e) {
                              let error;
                              if (!(e instanceof PasswordException)) {
                                error = e.response.data.message;
                                this.setState({
                                  ...this.state,
                                  alertType: 'error',
                                  apiMessage: error
                                });
                              }
                            }
                          }}
                        >
                          {({
                            errors,
                            handleBlur,
                            handleChange,
                            handleSubmit,
                            isSubmitting,
                            touched
                          }) => (
                            <form onSubmit={handleSubmit}>
                              {/* <Container
                              maxWidth="md"
                            > */}
                              <Grid
                                container
                                columnSpacing={5}
                                rowSpacing={0}
                                direction="row"
                                alignItems="center"
                                justifyContent="center"
                              >


                                <Grid item xs={12} md={12}>
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    position="relative"
                                  >
                                    <TextField
                                      error={Boolean(
                                        touched.full_name && errors.full_name
                                      )}
                                      fullWidth
                                      helperText={
                                        touched.full_name && errors.full_name
                                      }
                                      label={'Full name as per ID'}
                                      placeholder="eg. John Smith"
                                      margin="normal"
                                      name="full_name"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      variant="standard"
                                    />
                                    <Tooltip
                                      title={'Your fullname cannot be changed once your account has been created.'}
                                      placement={isSmallScreen ? "left" : "bottom"}>
                                      <Info className="tooltipStyle" />
                                    </Tooltip>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    position="relative"
                                  >
                                    <TextField
                                      error={Boolean(touched.email && errors.email)}
                                      fullWidth
                                      helperText={touched.email && errors.email}
                                      label={'Email address'}
                                      placeholder="eg. johnsmith@gmail.com"
                                      margin="normal"
                                      name="email"
                                      onBlur={handleBlur}
                                      onChange={(e) => { this.handleEmailChanged(e); handleChange(e) }}
                                      type="text"
                                      variant="standard"
                                    />
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={6}>
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    position="relative"
                                  >
                                    <FormControl
                                      fullWidth
                                      margin="normal"
                                      variant="outlined"
                                    >
                                      <InputLabel
                                        className={
                                          touched.username && errors.username
                                            ? 'Mui-error'
                                            : ''
                                        }
                                        htmlFor="outlined-adornment-username"
                                      >
                                        {/* {'Username'} */}
                                      </InputLabel>
                                      <TextField
                                        error={Boolean(
                                          touched.username && errors.username
                                        )}
                                        variant='standard'
                                        id="outlined-adornment-username"
                                        name="username"
                                        className="username_container"
                                        onBlur={handleBlur}
                                        onChange={handleChange}
                                        onKeyUp={this.checkUsername}
                                        label="Username"
                                        aria-describedby="username-helper-text"
                                      />
                                      <p id="username_regex" className="Mui-error">
                                        {'Username should be at least 5 or at most 18 characters long, cannot contain whitespace(" ") and can only use letters, numbers and limited special characters like period("."), dash("-") or underscore("_")'}
                                      </p>
                                      {touched.username && errors.username && (
                                        <FormHelperText
                                          className={
                                            touched.username && errors.username
                                              ? 'Mui-error'
                                              : ''
                                          }
                                          id="username-helper-text"
                                        >
                                          {'Username is required'}
                                        </FormHelperText>
                                      )}
                                    </FormControl>
                                    <Tooltip
                                      title={'You can use letters, numbers and certain limited special characters like period("."), dash("-") or underscore("_") in your username. Whitespace (" ") is not allowed. Please remember your username to login to Capital Dynamics\' websites.'}
                                      placement={isSmallScreen ? "left" : "bottom"}>
                                      <Info className="tooltipStyle" />
                                    </Tooltip>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={12}>
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    position="relative"
                                  >
                                    <Grid className="phoneContainer" sx={{ flexGrow: 1 }}>
                                      <Grid className="phoneCode">
                                        {/* <Select
                                          variant="standard"
                                          id="country-code-select-outlined"
                                          size="large"
                                          // placeholder={'Country Code'}
                                          // optionFilterProp="children"
                                          onChange={handleSelectChange}
                                          defaultValue=''
                                          sx={{ width: '100%', height: "90%" }}
                                          className={
                                            touched.country_code &&
                                              this.state.country_code == ''
                                              ? 'showError'
                                              : ''
                                          }
                                          renderValue={
                                            this.state.country_code !== "" ? undefined : () => <div style='color:#aaa'>{'Country Code'}</div>
                                          }
                                        >
                                          {CountryCodes.countries &&
                                            CountryCodes.countries.map((countries, index) => {
                                              return (
                                                <MenuItem
                                                  key={index}
                                                  value={
                                                    countries.dial_code +
                                                    '_' +
                                                    countries.code
                                                  }
                                                >
                                                  {countries.dial_code} {countries.name}
                                                </MenuItem>
                                              );
                                            })}
                                        </Select> */}
                                        <Autocomplete
                                          size='small'
                                          disableClearable
                                          popupIcon={<></>}
                                          PopperComponent={PopperMy}
                                          onChange={handleSelectChange}
                                          options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                                          groupBy={(option) => option.firstLetter}
                                          getOptionLabel={(option) => option.dial_code + ' ' + option.name}
                                          renderInput={(params) => <TextField {...params} label="Dial Code" />}
                                          isOptionEqualToValue={(option, value) => option.dial_code === value.dial_code}
                                          sx={{ width: '100%' }}
                                        />
                                        {touched.country_code &&
                                          this.state.country_code == '' &&
                                          isSubmitting == false && (
                                            <FormHelperText
                                              className={
                                                touched.country_code &&
                                                  this.state.country_code == ''
                                                  ? 'Mui-error'
                                                  : ''
                                              }
                                              id="country-code-helper-text"
                                            >
                                              {'Dial code is required'}
                                            </FormHelperText>
                                          )}
                                      </Grid>
                                      <FormControl
                                        margin="normal"
                                        variant="outlined"
                                        className="phoneNumber"
                                      >
                                        <InputLabel
                                          className={
                                            touched.phone_number && errors.phone_number
                                              ? 'Mui-error'
                                              : ''
                                          }
                                          htmlFor="outlined-adornment-phone-number"
                                        >
                                          {/* {'Phone number'} */}
                                        </InputLabel>
                                        <TextField
                                          error={Boolean(
                                            touched.phone_number && errors.phone_number
                                          )}
                                          id="outlined-adornment-phone-number"
                                          name="phone_number"
                                          placeholder="eg. 123456789"
                                          className="phone_number_container"
                                          onBlur={handleBlur}
                                          onChange={event => {
                                            handleChange(event);
                                            this.handlePhoneOTP(event);
                                          }}
                                          onKeyUp={this.checkPhoneNumber}
                                          label="Phone Number"
                                          aria-describedby="phone-number-helper-text"
                                          type="number"
                                          variant="standard"
                                        />
                                        <p id="phoneNumberRegex" className="Mui-error">
                                          {'Must be a valid phone number'}
                                        </p>
                                        {touched.phone_number && errors.phone_number && (
                                          <FormHelperText
                                            className={
                                              touched.phone_number &&
                                                errors.phone_number
                                                ? 'Mui-error'
                                                : ''
                                            }
                                            id="phone-number-helper-text"
                                          >
                                            {'Phone number is required'}
                                          </FormHelperText>
                                        )}
                                      </FormControl>
                                    </Grid>
                                    {/* <Tooltip
                              title={t('registerPage.phoneTooltip')}
                              placement={isSmallScreen ? "left" : "bottom"}>
                              <InfoCircleOutlined className="tooltipStyle" />
                            </Tooltip> */}
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={4}>
                                  <Box
                                    display="flex"
                                    flexDirection="row"
                                    position="relative"
                                  >
                                    <FormControl sx={{ marginTop: '10px' }} >
                                      <FormLabel >Gender</FormLabel>
                                      <RadioGroup
                                        onChange={handleChange}
                                      >
                                        <FormControlLabel
                                          name="gender" value="F" control={<Radio />} label="Female" />
                                        <FormControlLabel
                                          name="gender" value="M" control={<Radio />} label="Male" />
                                      </RadioGroup>
                                      {touched.gender && errors.gender && (
                                        <FormHelperText
                                          className={touched.gender && errors.gender
                                            ? 'Mui-error'
                                            : ''
                                          }
                                          id="gender-helper-text"
                                        >
                                          {'Gender is required'}
                                        </FormHelperText>
                                      )}
                                    </FormControl>
                                  </Box>
                                </Grid>
                                <Grid item xs={12} md={8}>
                                  <Grid
                                    container
                                    direction="column"
                                    justifyContent="space-around"
                                    alignItems="stretch"
                                  >
                                    <Grid item xs={12}>
                                      <FormControl variant="standard" sx={{ minWidth: '100%', marginBottom: '15px', marginTop: '15px' }}>
                                        <Autocomplete
                                          size='small'
                                          disableClearable
                                          popupIcon={<></>}
                                          PopperComponent={PopperMy}
                                          onChange={handleNationalityChange}
                                          options={options.sort((a, b) => -b.firstLetter.localeCompare(a.firstLetter))}
                                          groupBy={(option) => option.firstLetter}
                                          getOptionLabel={(option) => option.name}
                                          renderInput={(params) => <TextField {...params} label="Nationality" />}
                                          isOptionEqualToValue={(option, value) => option.name === value.name}
                                          sx={{ width: '100%' }}
                                        />
                                        {touched.nationality &&
                                          this.state.nationality == '' &&
                                          isSubmitting == false && (
                                            <FormHelperText
                                              className={
                                                touched.nationality &&
                                                  this.state.nationality == ''
                                                  ? 'Mui-error'
                                                  : ''
                                              }
                                              id="nationality-helper-text"
                                            >
                                              {'Nationality is required'}
                                            </FormHelperText>
                                          )}
                                      </FormControl>
                                    </Grid>
                                    <Grid item xs={12}>
                                      <InputLabel>Date of Birth</InputLabel>
                                      <DatePicker
                                        name="dob"
                                        disabledDate={disabledDate}
                                        defaultPickerValue={moment().subtract(18, 'years')}
                                        onChange={handleDOB}
                                        style={{ width: '100%' }}
                                      />
                                      {touched.dob &&
                                        this.state.dob == '' &&
                                        isSubmitting == false && (
                                          <FormHelperText
                                            className={
                                              touched.dob &&
                                                this.state.dob == ''
                                                ? 'Mui-error'
                                                : ''
                                            }
                                            id="dob-helper-text"
                                          >
                                            {'Date of Birth is required'}
                                          </FormHelperText>
                                        )}
                                    </Grid>
                                  </Grid>
                                </Grid>
                                <Grid item xs={12}>
                                  <FormControl variant="standard" sx={{ minWidth: '100%', marginTop: '15px' }} name="mailing_address">
                                    <TextField
                                      name="mailing_address"
                                      label="Mailing Address"
                                      multiline
                                      maxRows={3}
                                      onChange={handleChange}
                                      variant="standard"
                                      error={Boolean(
                                        touched.mailing_address && errors.mailing_address
                                      )}
                                    />
                                    {errors.mailing_address && (
                                      <FormHelperText
                                        className={touched.mailing_address && errors.mailing_address
                                          ? 'Mui-error'
                                          : ''
                                        }
                                        id="mailing_address-helper-text"
                                      >
                                        {'Mailing address is required'}
                                      </FormHelperText>
                                    )}
                                  </FormControl>
                                </Grid>
                                <Grid item xs={12}>
                                  <FormControl
                                    fullWidth
                                    margin="normal"
                                    variant="standard"
                                    className="password"
                                  >
                                    <InputLabel
                                      className={
                                        touched.password && errors.password
                                          ? 'Mui-error'
                                          : ''
                                      }
                                      htmlFor="outlined-adornment-password"
                                    >
                                      {/* {'Password'} */}
                                    </InputLabel>
                                    <TextField
                                      error={Boolean(
                                        touched.password && errors.password
                                      )}
                                      id="outlined-adornment-password"
                                      type={
                                        this.state.showPassword ? 'text' : 'password'
                                      }
                                      name="password"
                                      className="password_container"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      onKeyUp={this.checkPassword}
                                      InputProps={{
                                        endAdornment:
                                          <InputAdornment position="end">
                                            <IconButton
                                              onClick={this.handleClickShowPassword}
                                              onMouseDown={this.handleMouseDownPassword}
                                              edge="end"
                                              size="large"
                                            >
                                              {this.state.showPassword ? (
                                                <Visibility />
                                              ) : (
                                                <VisibilityOff />
                                              )}
                                            </IconButton>
                                          </InputAdornment>
                                      }}
                                      label={'Password'}
                                      aria-describedby="password-helper-text"
                                      variant="standard"
                                    />
                                    <p id="password_regex" className="Mui-error">
                                      {'Password does not meet requirements'}
                                      {/* {'New password should be 8 characters long alphanumeric with UPPERCASE, lowercase and at least one of the following special characters !@#$%^&*'} */}
                                    </p>
                                    {touched.password && errors.password && (
                                      <FormHelperText
                                        className={
                                          touched.password && errors.password
                                            ? 'Mui-error'
                                            : ''
                                        }
                                        id="password-helper-text"
                                      >
                                        {'Password is required'}
                                      </FormHelperText>
                                    )}
                                  </FormControl>
                                  <PasswordStrengthBar
                                    shortScoreWord={this.defaultPasswordScoreWords}
                                    scoreWords={this.passwordScoreWords}
                                    password={this.state.password}
                                  />
                                </Grid>
                                <Grid item xs={12}>
                                  <Typography component={'span'} variant={'body2'} style={{ fontSize: '14px' }}>
                                    <b>Password requirements:</b><br />
                                    <Box className='passwordRequirements'>
                                      {this.state.containLetter ? <Done color='success' /> : <Close color='error' />}
                                      <span>Must have an UPPERCASE and lowercase letter<br /></span>
                                    </Box>
                                    <Box className='passwordRequirements'>
                                      {this.state.containNumber ? <Done color='success' /> : <Close color='error' />}
                                      <span>Must have a number<br /></span>
                                    </Box>
                                    <Box className='passwordRequirements'>
                                      {this.state.containSpecial ? <Done color='success' /> : <Close color='error' />}
                                      <span>Must have one of these special characters (eg: !@#$%^&*)<br /></span>
                                    </Box>
                                    <Box className='passwordRequirements'>
                                      {this.state.minLength ? <Done color='success' /> : <Close color='error' />}
                                      <span>Must be at least 8 characters in length</span>
                                    </Box>
                                  </Typography>
                                </Grid>
                                <Grid item xs={12}>
                                  <FormControl
                                    fullWidth
                                    margin="normal"
                                    variant="outlined"
                                  >
                                    <InputLabel
                                      className={
                                        touched.password2 && errors.password2
                                          ? 'Mui-error'
                                          : ''
                                      }
                                      htmlFor="outlined-adornment-password2"
                                    >
                                      {/* {'Confirm password'} */}
                                    </InputLabel>
                                    <TextField
                                      error={Boolean(
                                        touched.password2 && errors.password2
                                      )}
                                      id="outlined-adornment-password2"
                                      type={
                                        this.state.showPassword2 ? 'text' : 'password'
                                      }
                                      name="password2"
                                      onBlur={handleBlur}
                                      onChange={handleChange}
                                      InputProps={{
                                        endAdornment:
                                          <InputAdornment position="end">
                                            <IconButton
                                              onClick={this.handleClickShowPassword2}
                                              onMouseDown={
                                                this.handleMouseDownPassword2
                                              }
                                              edge="end"
                                              size="large"
                                            >
                                              {this.state.showPassword2 ? (
                                                <Visibility />
                                              ) : (
                                                <VisibilityOff />
                                              )}
                                            </IconButton>
                                          </InputAdornment>
                                      }}
                                      label={'Confirm password'}
                                      aria-describedby="password2-helper-text"
                                      variant="standard"
                                    />
                                    {touched.password2 && errors.password2 && (
                                      <FormHelperText
                                        className={
                                          touched.password2 && errors.password2
                                            ? 'Mui-error'
                                            : ''
                                        }
                                        id="password2-helper-text"
                                      >
                                        {'Confirm password is required and must be matched with your password'}
                                      </FormHelperText>
                                    )}
                                  </FormControl>
                                </Grid>
                              </Grid>
                              <Box my={2}>
                                <Button
                                  color="primary"
                                  disabled={isSubmitting}
                                  fullWidth
                                  size="large"
                                  type="submit"
                                  variant="contained"
                                >
                                  {'Register'}
                                </Button>
                              </Box>
                              <Typography
                                color="textSecondary"
                                variant="body1"
                                align="center"
                              >
                                {'Have an account? '}
                                <Link
                                  to={"/?" + query}
                                  color="secondary"
                                  underline="none"
                                >
                                  {'Login'}
                                </Link>{' '}
                                {'here'}
                              </Typography>
                            </form>
                          )}
                        </Formik>
                      </Box>
                      {/* </Container> */}
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </Grid>
            {this.state.confirm === true &&
              <Dialog
                open={this.state.confirm}
                onClose={this.cancelSubmit}
              >
                <DialogTitle id="alert-dialog-title">
                  {"Confirm Personal details"}
                </DialogTitle>
                <DialogContent>
                  <DialogContentText id="alert-dialog-description" sx={{ whiteSpace: 'pre-line' }}>
                    Full Name: {this.state.data.full_name + '\n'}
                    Email Address: {this.state.data.email + '\n'}
                    Username: {this.state.data.username + '\n'}
                    Phone Number: {this.state.country_code + this.state.data['phone_number'] + '\n'}
                    Gender: {this.state.data['gender'] + '\n'}
                    Nationality: {this.state.nationality + '\n'}
                    Date of Birth: {this.state.dob + '\n'}
                    Mailing Address: {this.state.data['mailing_address']}
                  </DialogContentText>
                </DialogContent>
                <DialogActions>
                  <Button onClick={this.cancelSubmit}>Change Details</Button>
                  <Button onClick={this.confirmSubmit} autoFocus>
                    Confirm
                  </Button>
                </DialogActions>
              </Dialog>
            }
          </>
          :
          <Grid
            container
            spacing={0}
            direction="column"
            alignItems="center"
            justifyContent="center"
            style={{ minHeight: '100vh' }}
          >
            <Grid item xs={12} md={3}>
              <Card>
                <CardContent sx={{ textAlign: "center" }}>
                  <img src='/logo.png' alt="iCapital" width="50%" height="auto" />
                  <br />
                  <CheckCircle color='success' sx={{ fontSize: "100px", marginBottom: "30px" }} />
                  <Typography>
                    You have registered your Capital Dynamics account.
                    <br />
                    You will be redirected to the login page in a few seconds
                  </Typography>
                  <Box sx={{ display: "none" }}>
                    {setTimeout(function () {
                      window.location.replace("/?" + query);
                    }, 5000)}
                  </Box>
                </CardContent>
              </Card>
            </Grid>
          </Grid>
        }
      </>
    );
  }
}

export default function Register() {
  const navigator = useNavigate();
  const isSmallScreen = useMediaQuery('(max-width:620px)', { noSsr: true });

  return <RegisterForm navigator={navigator} isSmallScreen={isSmallScreen} />;
}
